import { createTheme } from '@mui/material/styles';

const display = '"Outfit Variable", "Noto Sans Lao Variable", system-ui, sans-serif';
const body = '"Inter Variable", "Noto Sans Lao Variable", system-ui, sans-serif';

export const theme = createTheme({
  cssVariables: { colorSchemeSelector: 'class' },
  colorSchemes: {
    dark: {
      palette: {
        mode: 'dark',
        primary: { main: '#E8B931', contrastText: '#1A1407' },   // gilded gold
        secondary: { main: '#2DD4BF' },                          // aurora teal
        background: { default: '#0A0E14', paper: '#121826' },
        text: { primary: '#E7ECF5', secondary: '#A9B4C7' },
      },
    },
    light: {
      palette: {
        mode: 'light',
        primary: { main: '#A87B1E', contrastText: '#FFFFFF' },   // deepened gold
        secondary: { main: '#0D9488' },
        background: { default: '#F6F3EC', paper: '#FFFFFF' },     // porcelain
        text: { primary: '#1B2230', secondary: '#5A6679' },
      },
    },
  },
  shape: { borderRadius: 14 },
  typography: {
    fontFamily: body,
    h1: { fontFamily: display, fontWeight: 700, letterSpacing: '-0.02em' },
    h2: { fontFamily: display, fontWeight: 700, letterSpacing: '-0.01em' },
    h3: { fontFamily: display, fontWeight: 600 },
    h4: { fontFamily: display, fontWeight: 600 },
    h5: { fontFamily: display, fontWeight: 600 },
    h6: { fontFamily: display, fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
    body1: { fontSize: '0.9375rem' },
  },
});
